<div class="modal-header bg-light">
  <div class="modal-title pull-left">
    <div class="mb-0 font-weight-bold">Drag a single file here to upload</div>
  </div>

  <button id="ist-excel-import-close-btn" type="button" class="close pull-right align-self-center" aria-label="Close" (click)="decline()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body bg-light">

  <div class="file-upload">

    <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)"
      (onFileLeave)="fileLeave($event)" accept=".xlsx,.xls,.csv">
      <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
        <div class="text-center color--black">
          <div class="my-3">Drag a single file here or <a id="ist-excel-import-browse-upload" class="color--blue" (click)="openFileSelector()"
              role="button">browse</a> to upload</div>
          <div class="remove-br">
            Do you currently enter your financials spreads in a spreadsheet?<br>
            <a role="button" class="color--blue" id="ist-excel-download-sample" (click)="downloadSampleFile()">Download a simple Excel template</a> and we'll help you map our
            template to<br>
            your main spreadsheet so for future reports,<br>
            you don't have to enter the financials again in our system.<br>
          </div>

          <div class="font-weight-bold mt-3">
            Prior to uploading, you must choose type of financials for each year of financials you are uploading.
          </div>

        </div>

      </ng-template>
    </ngx-file-drop>

  </div>
</div>
